
import { MainNavigation } from "./header/MainNavigation";
import { MobileNavigation } from "./header/MobileNavigation";
import { SearchBar } from "./header/SearchBar";
import { ActionButtons } from "./header/ActionButtons";
import { UnitIndicator } from "./header/UnitIndicator";
import { Breadcrumbs } from "./Breadcrumbs";

export function DashboardHeader() {
  return (
    <>
      <header className="bg-card border-b border-border/50 backdrop-blur-sm sticky top-0 z-40 min-w-fit">
        <div className="container mx-auto px-3 md:px-6 py-2 md:py-3 flex items-center justify-between gap-2 md:gap-4">
          <div className="flex items-center shrink-0">
            <MobileNavigation />
            <MainNavigation />
          </div>
          <div className="flex-1 max-w-md hidden sm:block">
            <SearchBar />
          </div>
          <div className="shrink-0">
            <ActionButtons />
          </div>
        </div>
      </header>
      <UnitIndicator />
      <Breadcrumbs />
    </>
  );
}
